export const validatePassword = password => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-+()'",./:;<=>[_`{}|~\]\\]).{8,}$/.test(password);
